import React from 'react'
import { AccountHeader } from '@mobi/component-library/Areas/Account'
import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'
import { FeatureIcon } from '@mobi/component-library/Assets/Icon'
import { Button } from '@mobi/component-library/Base/Buttons'
import { useNavigate } from 'react-router'
import { useDispatch } from 'react-redux'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { SignUpPageStyled } from '../../SignUp/Components/SignUpPage.styled'
import { setIsVerificationAccount } from '../../SignUp/Store'
import { routes } from '../../SignUp/Utils'
import { CrossIcon, List, ListItem } from './VerificationAccountPages.styled'

export const VerificationAccountInformationPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  return (
    <VerificationAccountPage>
      <AccountHeader
        alignItems='start'
        title={
          <Flex flexDirection='column' gap={spacing.md}>
            <FeatureIcon type='grey' size='xl' />
            <span>ID Verification</span>
          </Flex>
        }
        description={
          <span>
            This verification-only account is <b>limited to identity purposes only</b> and{' '}
            <b>does not allow:</b>
          </span>
        }
        style={{ marginBottom: '0rem' }}
      />
      <List>
        <ListItem>
          <CrossIcon />
          Online betting
        </ListItem>
        <ListItem>
          <CrossIcon />
          Withdrawals or depositing of funds
        </ListItem>
        <ListItem>
          <CrossIcon />
          Access to betting bonuses and offers
        </ListItem>
        <ListItem>
          <CrossIcon />
          Marketing or promotional communications
        </ListItem>
      </List>
      <div>
        If you want to to signup for full TABtouch access, press <b>Home</b> and continue with our
        standard signup process.
      </div>
      <Flex flexDirection='column' gap={spacing.md}>
        <Button
          isFullWidth
          color='primary'
          onClick={() => {
            dispatch(setIsVerificationAccount(true))
            navigate(routes.personalDetails)
          }}
        >
          Continue with ID Verification
        </Button>
        <Button isFullWidth color='tertiary_color' onClick={() => navigate(routes.home)}>
          Home
        </Button>
      </Flex>
    </VerificationAccountPage>
  )
}

export const VerificationAccountPage = styled(SignUpPageStyled)({
  ...font.size.lg,
  fontFamily: font.family.primary,
  fontWeight: font.weight.regular,
  color: colors.neutral[900],
  rowGap: spacing.bigx1,
})
